module.exports = __webpack_public_path__ + "img/icon-send-01.svg";